import React from 'react';
import { useAuth } from '../../context/AuthContext';

const Header: React.FC = () => {
  const { user, logout, isAdmin } = useAuth();

  return (
    <header className="bg-blue-600 text-white shadow-lg">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">MTG Budget Tracker</h1>
          <div className="flex items-center space-x-4">
            {user && (
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-2">
                  <span className="text-sm">Welcome, {user.username}</span>
                  {isAdmin() && (
                    <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs font-medium">
                      Admin
                    </span>
                  )}
                </div>
                <button
                  onClick={logout}
                  className="bg-red-600 hover:bg-red-700 px-3 py-1 rounded text-sm transition-colors"
                >
                  Logout
                </button>
              </div>
            )}
            <nav className="hidden md:flex space-x-4">
              <a href="/" className="hover:text-blue-200 transition-colors">
                Home
              </a>
              <a href="/cards" className="hover:text-blue-200 transition-colors">
                Cards
              </a>
              <a href="/decks" className="hover:text-blue-200 transition-colors">
                Decks
              </a>
              <a href="/tournaments" className="hover:text-blue-200 transition-colors">
                Tournaments
              </a>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
